import { Col, Row, Button, Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const FormActions = ({
  formik,
  userOU,
  tooltipOpen,
  toggleTooltip,
  handleEmail,
  handleResetGoogle,
  resetTooltipOpen,
  toggleResetTooltip,
}) => (
  <Row>
    <Col sm="1" className="mt-1 mt-md-0">
      {userOU.centro === 'ORIENTACIÓN' ? null : (
        <Button type="submit" color="success" className="mt-3 w-auto">
          <Icon.Save />
        </Button>
      )}
    </Col>
    <Col sm="11" className="mt-1 mt-md-0 d-flex justify-content-end">
      {userOU.centro === 'SUPERADMIN' && handleResetGoogle ? (
        <>
          <Button onClick={handleResetGoogle} className="mt-3 w-auto me-2" id="resetGoogleTooltip">
            <Icon.Key />
          </Button>
          <Tooltip
            placement="top"
            isOpen={resetTooltipOpen}
            target="resetGoogleTooltip"
            toggle={toggleResetTooltip}
          >
            Resetear contraseña de Google
          </Tooltip>
        </>
      ) : null}
      {(userOU.centro === 'SECRETARÍA' || userOU.centro === 'SUPERADMIN') &&
      formik.values.idAdditio !== '' ? (
        <>
          <Button onClick={handleEmail} className="mt-3 w-auto" id="reenviarTooltip">
            <Icon.Mail />
          </Button>
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target="reenviarTooltip"
            toggle={toggleTooltip}
          >
            Reenviar credenciales
          </Tooltip>
        </>
      ) : null}
    </Col>
  </Row>
);

FormActions.propTypes = {
  formik: PropTypes.object.isRequired,
  userOU: PropTypes.object.isRequired,
  tooltipOpen: PropTypes.bool,
  toggleTooltip: PropTypes.func.isRequired,
  handleEmail: PropTypes.func.isRequired,
  handleResetGoogle: PropTypes.func,
  resetTooltipOpen: PropTypes.bool,
  toggleResetTooltip: PropTypes.func,
};

export default FormActions;
